@use './gallery-item-vars';

:host {
  @include gallery-item-vars.wb-gallery-item-vars;

  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  width: 100%;
}

::slotted(:first-child) {
  margin-block-start: calc(var(--gallery-item-text-margin-block-start) + var(--gallery-gap));
}

::slotted(:not(:last-child)) {
  margin-block-end: var(--gallery-item-text-gap);
}

::slotted(.wb-heading) {
  color: var(--gallery-item-text-headline-color);
}

::slotted(.wb-text) {
  color: var(--gallery-item-text-body-color);
}
